import { SvgIcon, SvgIconProps } from '@mui/material';


/**
 * CcfReturnTabIcon used to disply open new tab icon in the custom workspace iframe panel
 * @param props - SvgIconProps
 * @example -- <CcfReturnTabIcon />
 */
export function CcfReturnTabIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.4 16V14.4H2.72L7.76 9.36L6.64 8.24L1.6 13.28V9.6H0V16H6.4Z" fill="#3F5C69"/>
        <path d="M1.6 3.2C1.6 2.32 2.32 1.6 3.2 1.6H12.8C13.68 1.6 14.4 2.32 14.4 3.2V12.8C14.4 13.68 13.68 14.4 12.8 14.4H8V16H12.8C14.56 16 16 14.56 16 12.8V3.2C16 1.44 14.56 0 12.8 0H3.2C1.44 0 0 1.44 0 3.2V8H1.6V3.2Z" fill="#3F5C69"/>
      </svg>
    </SvgIcon>
  );
}
  
export default CcfReturnTabIcon;